// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"a535bde5","417":"3269caeb","483":"ee65bd4e","597":"18a870f7","787":"070eb321","871":"da6340df"}[chunkId] + ".chunk.js";
};